<script>
import useSharedData from "@/use/SharedData";
import useConfiguration from "@/use/Configuration";
import {onMounted} from "vue";
import {useSecurityStore} from "@/stores/Security";

export default {
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            loading,
            backgroundColor,
            configurations,
            save,
        }
    }
};
</script>

<template>
    
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_GENERAL_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
            <v-tabs
                dense
                height="35"
                color="teal"
                :background-color="backgroundColor"
            >
                <v-tab>{{ $t('common.general') }}</v-tab>
                <v-tab>{{ $t('common.tax_information') }}</v-tab>
                <v-tab>{{ $t('common.note') }}</v-tab>
                
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <w-label :label="$t('common.company_name')"/>
                                <w-text-field v-model="configurations[35].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.address')"/>
                                <w-text-field v-model="configurations[36].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.member_number')"/>
                                <w-text-field v-model="configurations[51].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.social_capital')"/>
                                <w-text-field v-model="configurations[52].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.gps_position')"/>
                                <w-text-field v-model="configurations[125].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.comment')"/>
                                <w-text-area v-model="configurations[53].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.address')} 1`"/>
                                <w-text-field v-model="configurations[54].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.address')} 2`"/>
                                <w-text-field v-model="configurations[55].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.phone')"/>
                                <w-text-field v-model="configurations[56].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.fax')"/>
                                <w-text-field v-model="configurations[57].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.email')"/>
                                <w-text-field v-model="configurations[58].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.web_site')"/>
                                <w-text-field v-model="configurations[59].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="6">
                                <w-label :label="$t('common.tax_id')"/>
                                <w-text-field v-model="configurations[60].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.nis')"/>
                                <w-text-field v-model="configurations[61].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.taxation_article')"/>
                                <w-text-field v-model="configurations[62].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="$t('common.rc')"/>
                                <w-text-field v-model="configurations[63].strr"/>
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('common.rib')"/>
                                <w-text-field v-model="configurations[64].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.account')} 1`"/>
                                <w-text-field v-model="configurations[65].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.address')} ${$t('common.account')} 1`"/>
                                <w-text-field v-model="configurations[66].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.account')} 2`"/>
                                <w-text-field v-model="configurations[67].strr"/>
                            </v-col>
                            <v-col cols="6">
                                <w-label :label="`${$t('common.address')} ${$t('common.account')} 2`"/>
                                <w-text-field v-model="configurations[68].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('common.label')"/>
                                <w-text-area v-model="configurations[69].strr"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </template>
    </w-app>
</template>